import { useEffect, useMemo } from 'react';
import type { Product } from '@/features/products/types/products.types';
import type { PaymentSelection } from '../types/schedule.types';
import {
    ANOMALY_HINT,
    FIRST_COLLECTION_ANOMALY_HINT,
} from '../utils/quoteSummaryAnomalyHints';
import { buildQuoteSummaryPayment, type QuoteSummaryPaymentView } from '../utils/quoteSummaryPayment';

export const useQuoteSummaryPayment = (
    selection: PaymentSelection | undefined,
    schedulingMethods: Product['schedulingMethods'],
    currency: string,
): QuoteSummaryPaymentView => {
    const view = useMemo(
        () => buildQuoteSummaryPayment(selection, schedulingMethods, currency),
        [selection, schedulingMethods, currency],
    );
    const depositAnomaly = view.kind === 'schedule' ? view.depositAnomaly : undefined;
    const firstCollectionAnomaly = view.kind === 'schedule' ? view.firstCollectionAnomaly : undefined;

    // No telemetry channel exists in www, so console.warn is the channel; keyed on the code to fire once.
    // The prefix says anomaly, not failed closed: entered-amount-disagrees still renders its figure.
    useEffect(() => {
        if (depositAnomaly) {
            console.warn(
                `[quote] applied-deposit anomaly: ${depositAnomaly}. ${ANOMALY_HINT[depositAnomaly]}`,
            );
        }
    }, [depositAnomaly]);

    useEffect(() => {
        if (firstCollectionAnomaly) {
            console.warn(
                `[quote] first-collection anomaly: ${firstCollectionAnomaly}. ${FIRST_COLLECTION_ANOMALY_HINT[firstCollectionAnomaly]}`,
            );
        }
    }, [firstCollectionAnomaly]);

    return view;
};
